import { InjectionToken } from '@angular/core';

export const STOREON = new InjectionToken('Token for store object');
